/* eslint-disable import/prefer-default-export */

import { IntegrationCategoryParam, IntegrationItem } from '../../model'

type IntegrationsFilter = {
  search: string
  category: IntegrationCategoryParam
}

export function searchIntegrationsByFilter(integrations: IntegrationItem[], filter: IntegrationsFilter) {
  const searchRegExp = new RegExp(filter.search, 'i')

  return integrations.filter((integration) => {
    return searchRegExp.test(integration.name) && (filter.category === integration.category || !filter.category)
  })
}
